// frontend/packages/business-console/src/components/inbox/triageMeta.js
//
// Display metadata for the Inbox AI triage (Conversation.aiTriage). Intent +
// urgency labels/colors + an urgency rank, shared by the list row chips and the
// conversation detail. Read-only; the classification is computed server-side by
// the triage sweep.

export const INTENT_LABEL = {
  new_lead: 'New lead',
  quote_request: 'Quote request',
  scheduling: 'Scheduling',
  support: 'Support',
  spam: 'Spam',
  other: 'Other',
};

// Light chip colors (foreground + background). Kept subtle so the row stays
// readable; urgency carries the strongest color.
export const URGENCY_META = {
  high: { label: 'Urgent', fg: '#B91C1C', bg: '#FEE2E2' },
  medium: { label: 'Soon', fg: '#92400E', bg: '#FEF3C7' },
  low: { label: 'Low', fg: '#374151', bg: '#F3F4F6' },
};

export const INTENT_CHIP = { fg: '#3730A3', bg: '#EEF2FF' }; // indigo, neutral

// Higher = more urgent; for client-side ranking if/when a sort is added.
export const URGENCY_RANK = { high: 3, medium: 2, low: 1 };

export function intentLabel(intent) {
  return INTENT_LABEL[intent] || null;
}
